import React from "react";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";
import { FormGroup, FormFeedback, Input, Row, Col } from "reactstrap";
import {
  catchHandler,
  entriesToOptions,
  getRequestHeaders,
  getSelectStyles,
} from "../../utils";
let i = 0;
class FourthStep extends React.Component {
  state = {
    optionsLocatie: [],
    optionsDisciplina: [],
    optionsCurs: [],
    Locatie: "",
    Disciplina: "",
    Curs: "",
    Files: "",
    LocatieTouched: false,
    CursTouched: false,
    FilesTouched: false,
    UploadingFile: false,
    fileRef: "",
    fileError: "",
    isSubventionat: false,
    loading: false,
  };

  constructor(props) {
    super(props);
    this.isValidated = this.isValidated.bind(this);
    this.onLocationsSelectChange = this.onLocationsSelectChange.bind(this);
    this.onSubjectsSelectChange = this.onSubjectsSelectChange.bind(this);
    this.onCoursesSelectChange = this.onCoursesSelectChange.bind(this);
    this.onFilesInput = this.onFilesInput.bind(this);
  }

  componentDidMount() {
    const isSubventionat = Boolean(sessionStorage.getItem("isSubventionat"));
    this.setState({
      loading: true,
      isSubventionat,
    });

    axios
      .get(
        `/api/wizard/select-locations?subventionat=${isSubventionat}`,
        getRequestHeaders()
      )
      .then((res) => {
        const { data = [] } = res;
        this.setState({
          optionsLocatie: data.map(entriesToOptions),
        });
      })
      .catch(catchHandler)
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { isSubventionat, Locatie, Disciplina, Curs, optionsCurs, optionsLocatie } =
      nextState;
    const currentIsSubventionatStorage = Boolean(
      sessionStorage.getItem("isSubventionat")
    );
    if (isSubventionat !== currentIsSubventionatStorage) {
      this.setState({
        loading: true,
        isSubventionat: currentIsSubventionatStorage,
      });

      // Check if current course is deactivated for subventionat
      if (
        Disciplina &&
        Curs &&
        optionsCurs.find(({ value }) => value === Curs)
          ?.deactivatedForSubventionat &&
        currentIsSubventionatStorage
      ) {
        this.setState({ ["Curs"]: "" });
      }

      // Check if current location is still available
      const locationStillValid = optionsLocatie.find(
        ({ value }) => value === Locatie
      );

      // Reload locations with subventionat filter
      axios
        .get(
          `/api/wizard/select-locations?subventionat=${currentIsSubventionatStorage}`,
          getRequestHeaders()
        )
        .then((res) => {
          const { data = [] } = res;
          const newLocationsOptions = data.map(entriesToOptions);
          this.setState({
            optionsLocatie: newLocationsOptions,
          });

          // Clear location if it's no longer available
          const currentLocationStillValid = newLocationsOptions.find(
            ({ value }) => value === Locatie
          );
          if (Locatie && !currentLocationStillValid) {
            this.setState({
              Locatie: "",
              Disciplina: "",
              Curs: "",
              optionsDisciplina: [],
              optionsCurs: [],
            });
          }
        })
        .catch(catchHandler);

      // Reload subjects with subventionat filter if a location is selected
      if (Locatie) {
        axios
          .get(
            `/api/wizard/select-subjects/${Locatie}?subventionat=${currentIsSubventionatStorage}`,
            getRequestHeaders()
          )
          .then((res) => {
            const { data = [] } = res;
            const newSubjectsOptions = data.map(entriesToOptions);
            this.setState({
              optionsDisciplina: newSubjectsOptions,
            });

            // Clear subject if it's no longer available
            const currentSubjectStillValid = newSubjectsOptions.find(
              ({ value }) => value === Disciplina
            );
            if (Disciplina && !currentSubjectStillValid) {
              this.setState({
                Disciplina: "",
                Curs: "",
                optionsCurs: [],
              });
            }
          })
          .catch(catchHandler);
      }

      // Reload courses with subventionat filter if a subject is selected
      if (Disciplina) {
        axios
          .get(
            `/api/wizard/select-courses/${Disciplina}?subventionat=${currentIsSubventionatStorage}`,
            getRequestHeaders()
          )
          .then((res) => {
            const { data = [] } = res;
            this.setState({
              optionsCurs: data.map((entry) =>
                entriesToOptions(entry, { extra: "deactivatedForSubventionat" })
              ),
            });
          })
          .catch(catchHandler)
          .finally(() => {
            this.setState({ loading: false });
          });
      } else {
        this.setState({ loading: false });
      }
    }
  }

  // Important for Wizard
  isValidated() {
    this.setState({
      LocatieTouched: true,
      DisciplinaTouched: true,
      CursTouched: true,
      FilesTouched: true,
    });
    return Boolean(
      this.state.Locatie &&
        this.state.Disciplina &&
        this.state.Curs &&
        this.state.fileRef
    );
  }

  onLocationsSelectChange(option) {
    const { value = "" } = option || {};
    const { isSubventionat } = this.state;

    if (!value) {
      this.setState({
        optionsDisciplina: [],
      });
      this.setState({
        optionsCurs: [],
      });
    } else {
      this.setState({ loading: true });

      axios
        .get(
          `/api/wizard/select-subjects/${value}?subventionat=${isSubventionat}`,
          getRequestHeaders()
        )
        .then((res) => {
          const { data = [] } = res;
          this.setState({
            optionsDisciplina: data.map(entriesToOptions),
          });
        })
        .catch(catchHandler)
        .finally(() => {
          this.setState({ loading: false });
        });
    }

    this.setState({ ["Locatie"]: value, ["LocatieTouched"]: true });
    this.setState({ ["Disciplina"]: "" });
    this.setState({ ["Curs"]: "", optionsCurs: [] });
  }

  onSubjectsSelectChange(option) {
    const { value = "" } = option || {};
    const { isSubventionat } = this.state;

    if (!value) {
      this.setState({
        optionsCurs: [],
      });
    } else {
      this.setState({ loading: true });

      axios
        .get(
          `/api/wizard/select-courses/${value}?subventionat=${isSubventionat}`,
          getRequestHeaders()
        )
        .then((res) => {
          const { data = [] } = res;
          this.setState({
            optionsCurs: data.map((entry) =>
              entriesToOptions(entry, { extra: "deactivatedForSubventionat" })
            ),
          });
        })
        .catch(catchHandler)
        .finally(() => {
          this.setState({ loading: false });
        });
    }

    this.setState({ ["Disciplina"]: value, ["DisciplinaTouched"]: true });
    this.setState({ ["Curs"]: "" });
  }

  onCoursesSelectChange(option) {
    const { value = "" } = option || {};
    this.setState({ ["Curs"]: value, ["CursTouched"]: true });
  }

  onFilesInput(event) {
    const { target = {} } = event;
    const { files } = target;

    this.setState({ ["FilesTouched"]: true });

    if (!files?.length) {
      this.setState({ fileRef: "" });
      return;
    }

    // verify files
    for (let file of files) {
      const { type } = file;
      // pdf|jpeg|jpg|png limit - sync with server
      if (!type.startsWith("image/") && type !== "application/pdf") {
        this.setState({
          fileError: "Poti incarca doar fisiere PDF sau Imagini",
        });
        return;
      }

      // 20Mb limit - sync with server
      const maxFileSizeInMB = 20;
      const maxFileSizeInB = 1024 * 1024 * maxFileSizeInMB;

      if (file.size > maxFileSizeInB) {
        this.setState({
          fileError: "Poti incarca doar de maxim 20Mb",
        });
        return;
      }
    }

    const formData = new FormData();
    for (let file of files) {
      formData.append("files", file);
    }

    this.setState({ ["UploadingFile"]: true });
    axios
      .post(
        "/api/public-files/create-file",
        formData,
        getRequestHeaders({ requestHasFilesFlag: true })
      )
      .then(({ data }) => {
        const { fileRef = "" } = data || {};
        this.setState({ fileRef, fileError: "" });
        toast.success("Documentul a fost salvat cu succes");
      })
      .catch((err) => {
        this.setState({ fileRef: "", fileError: "Fisierul nu este valid" });
        catchHandler(null, err);
      })
      .finally(() => {
        this.setState({ ["UploadingFile"]: false });
      });
  }

  render() {
    const {
      optionsLocatie,
      optionsDisciplina,
      optionsCurs,
      Locatie,
      Disciplina,
      Curs,
      Files,
      LocatieTouched,
      DisciplinaTouched,
      CursTouched,
      FilesTouched,
      UploadingFile,
      fileError,
      fileRef,
    } = this.state;

    return (
      <Row>
        <Col md={4}></Col>
        <Col md={4}>
          <h5>Alege locația, disciplina, cursul</h5>
          <h6>
            Dacă nu găsești cursul/disciplina dorite în locația selectată de tine, înseamnă că acestea nu sunt disponibile în locația respectivă. Încearcă într-o altă locație apropiată.
          </h6>
          <p>
            Dacă nu ești sigur de cursul dorit, consultă ghidul cursurilor subvenționate{" "}
            <a
              href="/api/public/ghid-cursuri-subventionate.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              aici
            </a>
            .
          </p>
          <FormGroup className="mt-3">
            <Select
              name="Locatie"
              className={
                Boolean(LocatieTouched && !Locatie) ? "is-invalid" : ""
              }
              placeholder="Locatie"
              noOptionsMessage={() => <span>Fara rezultat</span>}
              isClearable={true}
              onChange={this.onLocationsSelectChange}
              styles={getSelectStyles(Boolean(LocatieTouched && !Locatie))}
              value={
                optionsLocatie.find(({ value }) => value === Locatie) || null
              }
              options={optionsLocatie}
            />
            <FormFeedback>
              {LocatieTouched && !Locatie && "Camp obligatoriu"}
            </FormFeedback>
          </FormGroup>
          <FormGroup>
            <Select
              name="Disciplina"
              className={
                Boolean(DisciplinaTouched && !Disciplina) ? "is-invalid" : ""
              }
              placeholder="Disciplina"
              noOptionsMessage={() =>
                !Locatie ? (
                  <span>Selectati o locatie</span>
                ) : (
                  <span>Fara rezultat</span>
                )
              }
              isClearable={true}
              onChange={this.onSubjectsSelectChange}
              styles={getSelectStyles(
                Boolean(DisciplinaTouched && !Disciplina)
              )}
              value={
                optionsDisciplina.find(({ value }) => value === Disciplina) ||
                null
              }
              options={optionsDisciplina}
            />
            <FormFeedback>
              {DisciplinaTouched && !Disciplina && "Camp obligatoriu"}
            </FormFeedback>
          </FormGroup>
          <FormGroup>
            <Select
              name="Curs"
              className={Boolean(CursTouched && !Curs) ? "is-invalid" : ""}
              placeholder="Curs"
              noOptionsMessage={() =>
                !Disciplina ? (
                  <span>Selectati o disciplina</span>
                ) : (
                  <span>Fara rezultat</span>
                )
              }
              isClearable={true}
              onChange={this.onCoursesSelectChange}
              styles={getSelectStyles(Boolean(CursTouched && !Curs))}
              value={optionsCurs.find(({ value }) => value === Curs) || null}
              options={optionsCurs}
            />
            <FormFeedback>
              {CursTouched && !Curs && "Camp obligatoriu"}
            </FormFeedback>
          </FormGroup>
          <h5>Carte de identitate (doar format .pdf)</h5>
          <FormGroup>
            <Input
              type="file"
              name="files"
              accept="application/pdf"
              className={
                Boolean(FilesTouched && (fileError || (!Files && !fileRef)))
                  ? "is-invalid"
                  : ""
              }
              styles={getSelectStyles(
                Boolean(FilesTouched && (fileError || (!Files && !fileRef)))
              )}
              onChange={this.onFilesInput}
              disabled={UploadingFile}
            />
            <FormFeedback>
              {FilesTouched &&
                (fileError || (!Files && !fileRef && "Camp obligatoriu"))}
            </FormFeedback>
          </FormGroup>
        </Col>
      </Row>
    );
  }
}

export default FourthStep;
